<template>
  <b-card>
    <b-row class="my-1">
      <b-col cols="12">
        <h4 class="mb-2" v-if="consultant.name">
          {{ consultant.name }}
          <span v-if="consultant.role" class="badge badge-primary badge-pill" style="margin-left: 7px">
            {{ consultant.role.name }}
          </span>
        </h4>
        <h5>Registro para líderes da campanha DNA Campeão 🎉</h5>
      </b-col>
    </b-row>
    <template v-if="loading.form">
      <b-row class="justify-content-md-center mt-2">
        <b-spinner big variant="primary" />
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col cols="12" md="3" class="mt-1">
          <b-form-group label="Missão Aprendiz (0 a 100)" label-for="apprentice">
            <b-form-input id="apprentice" v-model="apprentice" type="number"
              :class="{ 'is-invalid': v$.apprentice.$error }" />
            <div class="invalid-feedback">
              <span v-if="v$.apprentice.$invalid || v$.apprentice.$invalid">
                Você deve informar um valor entre 0 e 100
              </span>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" class="mt-1">
          <b-form-group label="Missão Focado (0 a 100)" label-for="focused">
            <b-form-input id="focused" v-model="focused" type="number" :class="{ 'is-invalid': v$.focused.$error }" />
            <div class="invalid-feedback">
              <span v-if="v$.focused.$invalid">
                Você deve informar um valor entre 0 e 100
              </span>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" class="mt-1">

          <b-form-group label="Missão Protagonista (0 a 240)" label-for="protagonist">
            <b-form-input id="protagonist" v-model="protagonist" type="number" :disabled="isProtagonistDisabled"
              :class="{ 'is-invalid': v$.protagonist.$error && !isProtagonistDisabled }" />
            <b-alert v-if="isProtagonistDisabled" variant="warning" show class="mt-1 py-1 px-2" style="font-size: 9px;">
              ⚠️ Este campo está desabilitado porque a missão <strong>Protagonista</strong>
              não se aplica para consultores com o papel
              <strong>{{ consultant.role.name }}</strong>.
            </b-alert>
          </b-form-group>
        </b-col>


        <b-col cols="12" md="3" class="mt-1">
          <b-form-group label="Missão Campeão (0 a 50)" label-for="champion">
            <b-form-input id="champion" v-model="champion" type="number" :max="maxAllowedChampion"
              :class="{ 'is-invalid': v$.champion.$error }" />
            <div class="invalid-feedback">
              <span v-if="v$.champion.$invalid">
                Você deve informar um valor entre 0 e {{ maxAllowedChampion }}
              </span>
            </div>

            <div class="mt-1" style="font-size: 11px; color: #ccc;">
              <div>
                💡 Você pode dar até <strong>{{ championLimit }} pontos</strong> para um PN ou distribuir entre a equipe.
              </div>

              <div class="mt-1">
                🎯 Disponível para este PN neste mês: <strong>{{ maxAllowedChampion }}</strong> pontos.
              </div>

              <div v-if="sumChampion > 0" class="mt-1">
                ✅ A equipe já recebeu <strong>{{ sumChampion }}</strong> pontos neste mês:

                <table class="mt-1" style="width: 100%; font-size: 11px; border-collapse: collapse;">
                  <tr v-for="(champion, index) in valueChampion" :key="index" style="border-bottom: 1px solid #444;">
                    <td style="width: 30px; text-align: center;">{{ champion.champion }}</td>
                    <td>{{ champion.name }}</td>
                  </tr>
                </table>
              </div>
            </div>

          </b-form-group>
        </b-col>



      </b-row>
      <b-row>
        <b-col cols="12" md="3" class="mt-1">
          <b-badge variant="light-warning" class="p-1">
            ATENÇÃO: Preencha este formulário até o dia 03 do mês para que a pontuação seja associada ao mês anterior
          </b-badge>
        </b-col>
      </b-row>
      <div class="d-flex mt-1 justify-content-end">
        <b-button :disabled="saving" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" @click="
          $router.push({
            name: 'consultant-dna-campaign',
            params: { id },
          })
          " class="lead-buttons">
          Cancelar
        </b-button>
        <b-button :disabled="saving" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
          class="lead-buttons ml-2" @click="onSubmit">
          {{ saving ? "Salvando..." : "Salvar" }}
        </b-button>
      </div>
    </template>
  </b-card>
</template>
<script>
import {
  BCard,
  BForm,
  BFormGroup,
  BButton,
  BFormInput,
  BFormTextarea,
  BCol,
  BRow,
  BSpinner,
  BBadge,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Ripple from "vue-ripple-directive";
import { minValue, maxValue } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import vSelect from "vue-select";
import { VMoney } from "v-money";
import { getVueSelectErrorClass } from "@/helpers/validators";
import * as types from "../store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import * as accountTypes from "@/modules/account/store/types";
import consultant from "@/router/routes/consultant";
import { ref, computed } from '@vue/composition-api';

export default {
  components: {
    BButton,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BCol,
    BRow,
    BSpinner,
    BBadge,
    vSelect,
  },
  props: ["id"],
  directives: {
    Ripple,
    money: VMoney,
  },
  setup() {
    const toast = useToast();

    const apprentice = ref(0);
    const focused = ref(0);
    const protagonist = ref(0);
    const champion = ref(0);
    const sumChampion = ref(0);
    const championLimit = ref(50);
    const championAvailable = ref(50);
    const championCurrent = ref(0);
    const maxAllowedChampion = computed(() => Math.max(championAvailable.value, championCurrent.value));


    const rules = {
      apprentice: { minValue: minValue(0), maxValue: maxValue(100) },
      focused: { minValue: minValue(0), maxValue: maxValue(100) },
      protagonist: { minValue: minValue(0), maxValue: maxValue(240) },
      champion: {
        minValue: minValue(0),
        maxValue: maxValue(maxAllowedChampion),
      },
    };

    const v$ = useVuelidate(rules, {
      apprentice,
      focused,
      protagonist,
      champion,
    });

    return {
      toast,
      v$,
      apprentice,
      focused,
      protagonist,
      champion,
      sumChampion,
      championLimit,
      championAvailable,
      championCurrent,
      maxAllowedChampion,
    };
  },
  data() {
    return {
      consultant: {
        role: {
          name: ""
        }
      },
      valueChampion: [],
      saving: false,
      loading: {
        form: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    }),
    isProtagonistDisabled() {
      const roleName = this.consultant?.role?.name;
      return roleName === "PNC" || roleName === "FA";
    }
  },
  mounted() {
    this.getConsultant(this.id).then((response) => {
      this.consultant = response.data;
    });
    this.getData();
  },
  methods: {
    ...mapActions({
      getConsultant: sharedTypes.GET_CONSULTANT,
      getDnaCampaign: types.GET_DNA_CAMPAIGN,
      saveDnaCampaign: types.SAVE_DNA_CAMPAIGN,
    }),
    getSelectErrorClass(thereIsError) {
      return getVueSelectErrorClass(thereIsError);
    },
    getData() {
      this.loading.form = true;
      this.getDnaCampaign({ consultant_id: this.id })
        .then((response) => {
          const data = response && response.data ? response.data : null;
          if (!data) {
            return;
          }
          if (data.campaign) {
            this.apprentice = data.campaign.apprentice || 0;
            this.focused = data.campaign.focused || 0;
            this.protagonist = data.campaign.protagonist || 0;
            this.champion = data.campaign.champion || 0;
          }
          this.valueChampion = data.value_champion || [];
          this.sumChampion = data.sum_champion || 0;
          this.championLimit = data.champion_limit || 50;
          this.championAvailable =
            data.champion_available !== undefined && data.champion_available !== null
              ? data.champion_available
              : this.championLimit;
          this.championCurrent = data.champion_current || 0;
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text:
                error?.response?.data?.message ||
                "Ocorreu um erro ao carregar a campanha. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading.form = false;
        });
    },
    async onSubmit() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.saving = true;
      this.saveDnaCampaign({
        consultant_id: parseInt(this.consultant.id),
        apprentice: parseInt(this.apprentice || "0"),
        focused: parseInt(this.focused || "0"),
        protagonist: parseInt(this.protagonist || "0"),
        champion: parseInt(this.champion || "0"),
      })
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso!",
              text: "Campanha salva com sucesso.",
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.$router.push({
            name: "consultant-dna-campaign",
            params: { id: this.id },
          });
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text:
                error?.response?.data?.message ||
                "Ocorreu um erro ao salvar a campanha. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>